import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

type OpenIconLinkProps = {
  to: string;
  label?: string;
  className?: string;
};

export function OpenIconLink({ to, label = 'Abrir', className = '' }: OpenIconLinkProps) {
  return (
    <Link
      to={to}
      target="_blank"
      rel="noopener noreferrer"
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center rounded-md p-1.5 text-secondary-500 transition-colors hover:bg-primary-50 hover:text-primary-600 ${className}`}
    >
      <ArrowTopRightOnSquareIcon className="h-5 w-5" />
    </Link>
  );
}
